export enum ParentType {
    Father = 'Баща',
    Mother = 'Майка',
    Grandfather = 'Дядо',
    Grandmother = 'Баба',
    Other = 'Друг(а)'
}